import gql from 'graphql-tag';

export const ACCOMMODATION_BOOKING = gql`
  query accommodationsBookings(
    $accommodationBookingId: Int
    $businessOwnerId: Int
    $token: String
  ) {
    accommodationsBookings(
      accommodationBookingId: $accommodationBookingId
      businessOwnerId: $businessOwnerId
      token: $token
    ) {
      id
      accommodation {
        id
        title
        photo
        productCode
        location
        guestsNumber
        fromDate
        toDate
        checkInTime
        checkOutTime
        cancellation
        cancellationNo
        bedDetails
        prices {
          id
          participant {
            participant
          }
          currency {
            currency
          }
          value
          day
        }
        futurePrices {
        id
        ratePlan {
          id
          title
        }
        ratePlanPrices {
          id
          value
          currency {
            currency
          }
          startDate
          endDate
        }
      }

        
        accommodationbookingSet {
          deactivationBooking
          id
          toDate
          fromDate
          isCanceled
        }
      }
      guestFirstName
      guestLastName
      guestPhoneNumber
      guestEmail
      platform
      fromDate
      toDate
      isCanceled
      payments {
        id
        paymentType
        currency {
          currency
        }
        totalPrice
      }
      bookedAddOns {
        id
        addOn {
          id
          title
          description
          prices {
            participant {
              participant
            }
            currency {
              currency
            }
            value
          }
        }
        currency {
          currency
        }
        addOnCount
        totalPrice
      }
      bookedMandatoryFees {
        id
        mandatoryFee {
          id
          title
          description
          prices {
            currency {
              currency
            }
            value
          }
        }
        currency {
          currency
        }
        mandatoryFeeCount
        totalPrice
      }  
      guests {
        participant {
          participant
        }
        guestsNumber
        totalPrice
      }

      relatedActivitiesBookings {
        id
        activity {
          id
          title
          titleNo
          pricesType
          futurePriceForm
          scheduleType
          prices {
            id
            participant {
              participant
            }
            currency {
              currency
            }
            days
            value
          }
          futurePrices {
            id
            ratePlan {
              id
              title
            }
            ratePlanPrices {
              id
              value
              currency {
                currency
              }
              participant {
                participant
              }
              startDate
              endDate
            }
          }
        }
        platform
        payments {
          paymentType
          currency {
            currency
          }
          totalPrice
        }
        startingDate
        endingDate
        schedule
        bookedAddOns {
          id
          addOn {
            id
            title
            titleNo
            description
            descriptionNo
            prices {
              participant {
                participant
              }
              currency {
                currency
              }
              value
            }
          }
          currency {
            currency
          }
          addOnCount
          totalPrice
        }
        guests {
          participant {
            participant
          }
          guestsNumber
          totalPrice
        }
      }
    }
  }
`;
